import { useState, type FormEvent } from 'react';
import { FolderPlus, PenLine } from 'lucide-react';
import { Modal } from '../../ui/Modal.js';

interface Props {
  titulo: string;
  etiqueta: string;
  valorInicial?: string;
  aceptar: string;
  modo: 'crear' | 'renombrar';
  alAceptar(nombre: string): void;
  alCerrar(): void;
}

export function DialogoNombre({ titulo, etiqueta, valorInicial = '', aceptar, modo, alAceptar, alCerrar }: Props) {
  const [nombre, setNombre] = useState(valorInicial);

  function enviar(evento: FormEvent) {
    evento.preventDefault();
    const limpio = nombre.trim();
    if (!limpio) return;
    alAceptar(limpio);
  }

  /** Al renombrar, la selección deja fuera la extensión: se cambia el nombre, no el tipo. */
  const alEnfocar = (e: React.FocusEvent<HTMLInputElement>) => {
    const punto = valorInicial.lastIndexOf('.');
    if (modo === 'renombrar' && punto > 0) e.target.setSelectionRange(0, punto);
    else e.target.select();
  };

  return (
    <Modal
      titulo={titulo}
      icono={modo === 'crear' ? <FolderPlus size={17} /> : <PenLine size={17} />}
      alCerrar={alCerrar}
      pie={
        <>
          <button className="btn" onClick={alCerrar}>
            Cancelar
          </button>
          <button className="btn btn--primario" onClick={enviar} disabled={!nombre.trim()}>
            {aceptar}
          </button>
        </>
      }
    >
      <form onSubmit={enviar}>
        <div className="campo" style={{ marginBottom: 0 }}>
          <label htmlFor="nombre">{etiqueta}</label>
          <input
            id="nombre"
            className="input"
            autoFocus
            value={nombre}
            onFocus={alEnfocar}
            onChange={(e) => setNombre(e.target.value)}
            onKeyDown={(e) => {
              // El botón que confirma vive en el pie del diálogo, fuera del
              // formulario, así que Enter necesita su propio manejador.
              if (e.key === 'Enter') enviar(e);
            }}
            maxLength={200}
          />
          <span className="muted" style={{ fontSize: 11 }}>
            No se admiten los caracteres \ / : * ? " &lt; &gt; |
          </span>
        </div>
      </form>
    </Modal>
  );
}
